<template>
<div class="chapter">
<div class="inner_page">
<p class="imagef"><img alt="image" src="images/p15.jpg"/></p>
<p class="center">GRAMMAR GREMLIN</p>
<p class="center-text"><em class="italic">This book has been professionally edited and proofread. However, sometimes typos can slip through the cracks. Please note that I take these very seriously, so if you find any errors, email the Grammar Factory team at <a href="mailto:info@grammarfactory.com">info@grammarfactory.com</a> and we’ll send you a free Grammar Gremlin as a thank you.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?7955d7be